import { handleLocalStorage } from '@/assets/js/utils.js';
export default {
  created() {
    var _JSON$parse;
    const env = handleLocalStorage('get', 'partylineConfig') ? (_JSON$parse = JSON.parse(handleLocalStorage('get', 'partylineConfig'))) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.apiEnv : '';
    const isCommentator = window.location.href.includes('commentator');
    const publicPath = window.location.hostname.includes('intercom') ? 'intercom' : 'partyline';
    window.location.href = location.protocol + '//' + location.host + `/${publicPath}?join_id=' + id + ${env ? '&' + env : ''} + ${isCommentator ? '&commentator' : ''}`;
  }
};